import type { Booth, UpsertBoothRequest } from '@cibli/shared';

import api from './api';

export async function upsertBooth(body: UpsertBoothRequest) {
  return api.patch<Booth | Partial<Booth>, UpsertBoothRequest>(`/booths`, body, {
    showErrorToast: true,
  });
}
